import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FormItem from '../FormComponents/FormItem';
import { personalizationDataShape } from '../formPropTypes';

const AccountLookupStep = ({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  isSubmitting,
  setHasCRMResults,
  footerNav,
}) => {
  const [formHasErrors, setFormHasErrors] = useState(Object.keys(errors).length && errors.email);

  const setHasCRMResultsCallback = useCallback(() => {
    setHasCRMResults(false);
  }, [setHasCRMResults]);

  useEffect(() => {
    setHasCRMResultsCallback();
  }, [setHasCRMResultsCallback]);

  useEffect(() => {
    if (Object.keys(errors).length && errors.email) {
      setFormHasErrors(true);
    } else {
      setFormHasErrors(false);
    }
  }, [errors]);

  return (
    <div
      className={classNames({ hasWholeFormErrors: formHasErrors })}
      data-testid="personalization-step:lookup"
    >

      <div className="modal__section">
        <h1 className="modal__subsection modal__title modal__title--short">Personalize YourTour</h1>
        <div className="modal__subsection modal__description modal__description--short">
          Enter a first name and/or a last name and/or a valid email address.
          {' '}
          Click CONTINUE to proceed.
        </div>
      </div>

      <div className="form__items modal__section">

        <div className="form__items__row">
          <FormItem
            handleChange={handleChange}
            handleBlur={handleBlur}
            values={values?.first_name}
            touched={touched}
            errors={errors}
            type="text"
            name="first_name"
            placeholder="First Name"
            autoFocus
          />

          <FormItem
            handleChange={handleChange}
            handleBlur={handleBlur}
            values={values?.last_name}
            touched={touched}
            errors={errors}
            type="text"
            name="last_name"
            placeholder="Last Name"
          />
        </div>

        <FormItem
          handleChange={handleChange}
          handleBlur={handleBlur}
          values={values?.email}
          touched={touched}
          errors={errors}
          type="email"
          name="email"
          placeholder="Email Address"
        />

      </div>

      <div className="modal__section modal__btns modal__btns--inline">
        <button
          disabled={isSubmitting}
          type="submit"
          className={classNames('modal__btn modal__btn--secondary modal__btn--inline', {
            'modal__btn--working': isSubmitting,
          })}
          data-testid="personalization-continue"
        >
          { isSubmitting ? 'Searching . . .' : 'Continue' }
        </button>
      </div>

      {footerNav}

    </div>
  );
};

AccountLookupStep.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  values: personalizationDataShape.isRequired,
  errors: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
  touched: PropTypes.shape({}).isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setHasCRMResults: PropTypes.func.isRequired,
  footerNav: PropTypes.node.isRequired,
};

export default AccountLookupStep;
